import { Cache, DataStoreOptions, MetaRecordMaskResource, SearchQuery } from '@skinsoft/types'
import { Proxy } from '@skinsoft/network'
import { DataStore } from '@skinsoft/data-store/src/data-store'

export class MetaRecordMaskDataStore extends DataStore<MetaRecordMaskResource & { id: string }> {

    public static getInstance() {
        if (!MetaRecordMaskDataStore.instance) {
            MetaRecordMaskDataStore.instance = new MetaRecordMaskDataStore();
        }

        return MetaRecordMaskDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$metaRecordMaskDataStore = MetaRecordMaskDataStore.getInstance();
    }

    private static instance: MetaRecordMaskDataStore = null as any;

    constructor(proxy?: Proxy, cache?: Cache<MetaRecordMaskResource>) {
        super(`/meta-record-masks`);
    }

    protected initializeDataFetcher() {
        //throw new Error('Method not implemented.');
    }

    protected initializeDataPusher() {
        //throw new Error('Method not implemented.');
    }

    // @ts-ignore
    public searchAll(searchQuery: SearchQuery, pathAndValueToCheck?: any, searchEndpointOverride: string | null = null, options: DataStoreOptions = {}, onlyOnLocallyCreated: boolean = false, forceSearchTextId: boolean = false) {
        throw new Error("This method is not implemented in this subclass")
        // logger
    }
}